import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectDiscountData } from 'src/app/shareModule/states/nearby';
import { StoryKachiingComponent } from '../../story-kachiing/story-kachiing.component';
import { environment } from 'src/environments/environment';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import Swal from 'sweetalert2';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'app-estimator-modal',
  templateUrl: './estimator-modal.component.html',
  styleUrls: ['./estimator-modal.component.scss'],
})
export class EstimatorModalComponent implements OnInit, OnDestroy {
  @Input() filter: string = '';
  @Input() selectedMapCategory = null;
  @Input() currentSelectedTypes = null;

  @Output()
  public viewProd = new EventEmitter();

  get popupImage(): any {
    return this.commonService.getPopupImageByFilterAndType(
      this.filter,
      'estimator'
    );
  }
  public bookNowText = '';
  public variableSuperGroups = [];
  public selectedVariableSuperGroup = null;
  public selectedVariableGroup = null;
  public selectedSubVariablesIds = new Set();
  public imgUrl = environment.ImageUrl;
  public isAdmin = false;
  public modalRef = null;

  public postalCodeOfUser = '';
  public hasAcceptedTerms = false;
  public recommendedProducts = [];
  public selectedVariable = null;
  public estimatorTitle = 'Estimate';
  public estimatorDescription =
    'Review your selected group and variables before submitting.';
  public popupLeaderColor = '#000000';
  public currentBookText = ''
  public currentBookProduct: any = {}
  public infosPage = ''
  public loading = false;
  public currentCategoryBookingQuestions = []
  public phoneOfUser = ''

  public readonly INFO_PAGE = 'info-page'
  public readonly LIST_PAGE = 'list-page'
  public readonly BOOK_PAGE = 'book-page'

  private destroy$ = new Subject<void>();
  private subVars = new Map();
  private vars = new Map();



  @ViewChild('bookingRecommendations')
  private bookingRecommendationsModal: TemplateRef<any>;

  @ViewChild('finalBookModal')
  private finalBookModalModal: TemplateRef<any>;

  private bookButtonFlipInterval = null;

  constructor(
    public commonService: CommonService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private roleService: RoleService,
    private local: LocalServiceService,
    private customerService: CustomerService,

    @Optional() public activeModal: NgbActiveModal,
    @Optional()
    private bottomSheetRef?: MatBottomSheetRef<EstimatorModalComponent>
  ) {}
  ngOnDestroy(): void {
    this._updateUrlWithQueryParam('estimator', null);
    if (this.bookButtonFlipInterval) {
      clearInterval(this.bookButtonFlipInterval);
      this.bookButtonFlipInterval = null;
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.store
      .pipe(select(selectDiscountData), takeUntil(this.destroy$))
      .subscribe((discountData: any) => {
        if (discountData) {
          this.bookNowText = discountData.bookNowText || 'Book Now';
          this.estimatorTitle = discountData.estimatorTitle || 'Estimate';
          this.estimatorDescription =
            discountData.estimatorDescription ||
            'Review your selected group and variables before submitting.';
          this.cdr.detectChanges();
        }
      });

       try {
      this.currentCategoryBookingQuestions = JSON.parse(
        this.typeOrCategoryData.mapQuestions ?? '[]',
      );
    } catch (e) { }

    this.bookButtonFlipInterval = setInterval(() => {
      for (const prod of this.recommendedProducts) {
        if (prod.customBookButton) {
          console.log('custom book button');
          if (prod.customBookButton == prod.activeButtonText) {
            prod.activeButtonText = '';
          } else {
            prod.activeButtonText = prod.customBookButton;
          }
        }
      }
    }, 3500);

    // Subscribe to map customization changes
    this.commonService.mapCustomizationObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.popupLeaderColor = data?.popupLeaderColor ?? '#000000';
        this.cdr.detectChanges();
      });

    this.checkAdmin();
    this.loadVariableData();

    if (!this.filter) {
      this.filter = this.getFilter();
    }
    const user = this.local.getUser();
    if(user){
      this.postalCodeOfUser = user.postalCode
    }
  }
  private checkAdmin() {
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isAdmin = !!this.roleService?.roles?.userType.includes('ADMIN');
      });
  }
  public openProd(prod) {
    this.viewProd.next(prod);
  }
  public book(prod) {
    this.currentBookProduct = prod;
    console.log(prod)
    this.infosPage = this.INFO_PAGE;

    // this.modalRef = this.modalService.open(this.finalBookModalModal, {
    //   windowClass: 'final-book-modal',
    //   size: 'md',
    //   centered: true,
    // });
  }
  private  async getUsersLocation() : Promise<any>{
    if(!this.sharedService.isBrowser()){
      return null;
    }
    return new Promise(
      (res, rej) =>{
          navigator.geolocation.getCurrentPosition( pos=> res(
            {lat: pos.coords.latitude, lng: pos.coords.longitude}
          ), err => rej(err))
      }
    )
   

  }
public async fetchRecommendedProducts() {
  let userLatLong = ''
  if (this.postalCodeOfUser?.length !== 6) {
    try{
       userLatLong = await this.getUsersLocation()
    }catch(e){
      this.toastr.info("Please allow location", "Location", {timeOut: 2000})
    }
  }else{
    userLatLong = await this.local.getLatLongByPostalCode(this.postalCodeOfUser);
  }




  if(this.currentSelectedTypes?.length){
    this.auth.fetchProductsBasedOnTypes({
       types: [this.currentSelectedTypes[0].id],
        //...this.getLocationCondition(),
    }).subscribe({
      next: (data: any) => this.setRecommendedProducts(data.data, userLatLong)
    })
     
  }else{
      const payload = {
    limit: 10,
    userLatLong,
    radius: 10,
    basedProduct: 'all',
    categoryId:  this.typeOrCategoryData?.categorieChildId ||  this.typeOrCategoryData?.id,
  };
  this.customerService.getMemberShopProductList(payload).subscribe({
    next: (data) => {
      this.setRecommendedProducts(data.body.data, userLatLong)
    }
  });
}
}

private setRecommendedProducts(products, userLatLong){
   this.recommendedProducts = products;

      const getDistance = (prod, userLatLong) => {
        let latLong = prod?.latLong;

        if (typeof latLong === "string") {
          try {
            latLong = JSON.parse(latLong);
          } catch (e) {}
        }

        const rv = this.local.isWithinRadius(latLong, userLatLong, 5);
        return rv;
      };

      // First sort
      this.recommendedProducts.sort((a, b) => {
        const infoB = this.commonService.getProductInformationScore(b);
        const infoA = this.commonService.getProductInformationScore(a);

        let distanceA = getDistance(a, userLatLong)?.realDistance;
        let distanceB = getDistance(b, userLatLong)?.realDistance;

        if (!distanceA) distanceA = 5;
        if (!distanceB) distanceB = 5;

        const distanceDiff = distanceA - distanceB;

        if (distanceDiff) {
          return distanceDiff;
        }
        return infoA - infoB;
      });

      // ForEach block
      this.recommendedProducts.forEach((prod) => {
        let latLong = prod.latLong;

        if (typeof latLong === "string") {
          try {
            latLong = JSON.parse(prod.latLong);
          } catch (e) {
            console.error(e);
          }
        }

        const rv = this.local.isWithinRadius(latLong, userLatLong, 10);
        // console.log({ rv });
      });

      // Second sorting pass
      this.recommendedProducts = this.recommendedProducts.sort((a, b) => {
        let distanceA = getDistance(a, userLatLong)?.realDistance;
        let distanceB = getDistance(b, userLatLong)?.realDistance;

        const distanceDiff = distanceA - distanceB;
        if (distanceDiff) return distanceDiff;

        return 0;
      });

      // Final processing
      this.recommendedProducts.forEach((prod) => {
        let latLong = prod.latLong;

        if (typeof latLong === "string") {
          try {
            latLong = JSON.parse(prod.latLong);
          } catch (e) {
            console.error(e);
          }
        }

        try {
          prod.sellerInfo = JSON.parse(prod.seller_info);
        } catch (e) {
          console.error(e);
        }

        const isWithinRadius = this.local.isWithinRadius(
          userLatLong,
          latLong,
          10
        );

        prod.isWithinRadius = isWithinRadius.check;
        prod.distance = isWithinRadius.distance;
      });
    
}

  private alert({ title, message }) {
    return Swal.fire({ title, text: message, icon: 'warning' });
  }
  private openListPage(){
        this.fetchRecommendedProducts()
            this.infosPage = this.LIST_PAGE
            this.modalRef = this.modalService.open(
              this.bookingRecommendationsModal,
              {
                windowClass: 'booking-recommendations-modal',
                size: 'md',
                centered: true,
              }
            );
          
          
        

  }

  submitBookingResponses() {
    try {
      const { id, isType } = this.getCurrentCategoryOrTypeId();
      console.log('submitting response');

      // if (this.phoneOfUSer == '' || this.phoneOfUSer == null) {
      //   return this.alert({
      //     title: 'Submit contact number to continue',
      //     message: '',
      //   });
      // }

      // if (this.phoneOfUSer.toString().length != 8) {
      //   console.log(this.phoneOfUSer.toString().length);
      //   return this.alert({
      //     title: 'Please enter a valid phone number',
      //     message: '',
      //   });
      // }

      if (!this.hasAcceptedTerms) {
        return this.alert({
          title:
            'Please confirm you have read and agree to the Terms and Conditions to continue',
          message: '',
        });
      }

      const calculateResult = `${this.calculateTotal()} - ${this.calculateMaxTotal()}`;

      // for (const question of this.currentCategoryBookingQuestions) {
      // await this.auth
      //   .saveMapQuestionsResponse(
      //     id,
      //     question.questionText ?? '',
      //     question.answer ?? '',
      //     isType,
      //     this.customUserId
      //   )
      //   .toPromise();
      // }
      //    'Phone number of booker',
      // //       this.phoneOfUSer,

      const variantAnswers = []
      let selectedVariants = []
      if(this.currentBookProduct.memberShopProductsVariations.length){
      for(const variant of this.currentBookProduct.memberShopProductsVariations){
        if(variant.selected){
            selectedVariants.push(variant.value)
        }
      }
      if(selectedVariants.length){
        variantAnswers.push({
            questionText: `Selected Variants`,
            answer: selectedVariants.join(', ')
          })
        }
    }
      this.loading = true;
      this.auth
        .bulkSaveMapQuestionResponses(
          id,
          [
            ...variantAnswers,
            ...this.currentCategoryBookingQuestions,
            {
              questionText: 'Range',
              answer: calculateResult,
            },
            {
              questionText: 'Phone number of booker:',
              answer: this.phoneOfUser + '',
            },
            {
              questionText: 'Postal code of booker:',
              answer: this.postalCodeOfUser + '',
            },
            // ...this.getVariablesResponse(),
          ],
          isType ? 'type' : 'category',
          this.local?.getUser()?.id ?? (Math.random() * 100000).toFixed()
        )
        .subscribe({
          next: () => {
            this.toastr.success('Saved');
            this.loading = false
            this.modalService.dismissAll()
            //this.modalRef?.close();
            //this.activeModal?.close();
            //this.bottomSheetRef?.dismiss();
            //this.modalRef = this.modalService.open(this.bookingRecommendationsModal,  { size: 'md', centered: true });
            //this.openListPage()
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.loading = false
            this.toastr.error(error.error.message);
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  private getLocationCondition;

  // private getVariablesResponse() {
  //   if (!this.selectedVariableGroup || !this.selectedSubVariablesIds) {
  //     return [];
  //   }
  //   const ans: any[] = [
  //     {
  //       isVariable: true,
  //       questionText: 'Order:',
  //       answer:
  //         this.selectedVariableGroup?.title +
  //         '\n\n' +
  //         this.getSelectedSubTitles().join(','),
  //       selectedGroupId: this.selectedVariableGroup?.id ?? 'none',
  //       selectedSubVarIds: Array.from(this.selectedSubVariablesIds),
  //     },
  //   ];

  //   // {
  //   //   isVariable: true,
  //   //   questionText: 'Total:',
  //   //   answer: this.calculateTotal() + '(overall)',
  //   // },

  //   return ans;
  // }

  public selectSuperGroup(sg) {
    this.selectedVariableSuperGroup = sg;
    this.loadVariableData();
    this.selectedVariable = null;
    this.selectedVariableGroup = null;
    this.selectedSubVariablesIds.clear();
    this.cdr.markForCheck();
  }

  public submit() {
    let ans = [];
    const maxTotal = this.calculateMaxTotal();
    if (maxTotal) {
      ans.push({
        isVariable: true,
        questionText: 'Max Total',
        answer: maxTotal.toString() + '(Max)',
      });
      ans.push({
        isVariable: true,
        questionText: 'Min Total:',
        answer: this.calculateTotal() + '(Min)',
      });
    } else {
      ans.push({
        isVariable: true,
        questionText: 'Total:',
        answer: this.calculateTotal() + '(overall)',
      });
    }
  }
  getCurrentCategoryOrTypeId() {
    console.log(this.selectedMapCategory, this.currentSelectedTypes);
    return this.commonService.getCategoryOrTypeId(
      this.selectedMapCategory,
      this.currentSelectedTypes
    );
  }

  public openModal(template, others = {}) {
    this.modalRef = this.modalService.open(template, others);
  }

  onVariableSuperGroupTabChange(newIndex) {
    this.selectedVariableSuperGroup = this.variableSuperGroups[newIndex];
    this.cdr.detectChanges();
  }
  loadVariableData() {
    const { id, isType } = this.getCurrentCategoryOrTypeId();
    console.log(id, isType, 'ID AND IS TYPE');
    this.auth.getBookingVariableSuperGroupsByCategory(id, isType).subscribe({
      next: (res: any) => {
        this.variableSuperGroups = res.body;
        console.log(this.variableSuperGroups, 'VARIABLE SUPER GROUPS');
        this.setupVariableData();

        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.toastr.error(err.error.message);
        console.error(err);
      },
    });
  }
  private calculateFromBase(base) {
    let rv = base;
    const selectedSubGroup = this.selectedVariableGroup;
    if (!selectedSubGroup) {
      return rv;
    }

    for (const variable of selectedSubGroup.bookingVariables) {
      for (const subVariable of variable.bookingSubVariables) {
        if (this.selectedSubVariablesIds.has(subVariable.id)) {
          if (subVariable.isPercent) {
            rv += (subVariable.amount / 100) * selectedSubGroup.value;
          } else {
            rv += subVariable.amount;
          }
        }
      }
    }
    return Math.max(
      rv - (this.selectedVariableSuperGroup?.proximityRebateValue ?? 0),
      0
    ).toFixed(2);
  }

  public calculateMaxTotal() {
    if (!this.selectedVariableGroup.maxValue) {
      return 0;
    }
    return this.calculateFromBase(this.selectedVariableGroup?.maxValue);
  }
  public calculateTotal() {
    return this.calculateFromBase(this.selectedVariableGroup?.value);
  }
  setupVariableData() {
    if (this.selectedVariableSuperGroup) {
      this.selectedVariableSuperGroup = this.variableSuperGroups.find(
        (sg) => sg.id == this.selectedVariableSuperGroup.id
      );
    } else {
      if (this.variableSuperGroups) {
        this.selectedVariableSuperGroup = this.variableSuperGroups[0];
      }
    }
    this.cdr.detectChanges();
  }

  public get proximityRebateValue() {
    return this.selectedVariableSuperGroup?.proximityRebateValue ?? 0;
  }
  public close(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }

  public closeBookingInfos(): void {
    this.modalRef?.close();
    this.modalRef = null;
  }

  get typeOrCategoryData() {
    return this.currentSelectedTypes?.length
      ? this.currentSelectedTypes[0]
      : this.selectedMapCategory;
  }

  get bookingMoreInfos() {
    return this.typeOrCategoryData?.bookingMoreInfos;
  }

  /**
   * All dropdowns are considered selected when every variable that exposes
   * sub-variables has a picked option (subVar checkbox).
   */
  get hasCompletedDropdownSelections(): boolean {
    if (!this.selectedVariableGroup?.bookingVariables?.length) {
      return false;
    }

    return this.selectedVariableGroup.bookingVariables.every(
      (variable: any) => {
        if (!variable?.bookingSubVariables?.length) {
          return true;
        }

        const selectedSubVarId = variable?.selectedSubVarId;
        return (
          !!selectedSubVarId &&
          this.selectedSubVariablesIds.has(selectedSubVarId)
        );
      }
    );
  }

  get canShowActionButtons(): boolean {
    return (
      !!this.selectedVariableSuperGroup &&
      !!this.selectedVariableGroup &&
      this.hasCompletedDropdownSelections 
    );
  }

  toggleSelectSubGroup(subGroup) {
    if (this.selectedVariableGroup) {
      this.selectedVariableGroup = null;
    } else {
      this.selectedVariableGroup = subGroup;
    }
  }

  private _updateUrlWithQueryParam(key: string, value: string | null) {
    if (!this.sharedService.isBrowser()) {
      return;
    }
    this.commonService.updateUrlWithQueryParam(key, value);
  }

  private getFilter(): string {
    let filter = 'map';
    if (this.selectedMapCategory?.id) {
      filter += `-${this.selectedMapCategory.id}`;
    }
    if (this.currentSelectedTypes?.length) {
      filter += `-${this.currentSelectedTypes[0]?.id}`;
    }
    return filter;
  }

  openStore(): void {
    // Close the current modal first
    this.close();

    // Update URL to include story=1 parameter (remove booking=1 if present)
    this._updateUrlWithQueryParam('booking', null);
    this._updateUrlWithQueryParam('story', '1');

    // Open story-kachiing modal
    const modalRef = this.modalService.open(StoryKachiingComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'story_modal',
    });

    // Pass filter and category data to the modal component
    const componentInstance =
      modalRef.componentInstance as StoryKachiingComponent;
    componentInstance.filter = this.filter || this.getFilter();
    componentInstance.isBookingNow = true;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.openShowBookingsModal.subscribe(() => {
      // Handle booking modal opening if needed
      modalRef.close();
    });

    // Remove query param when modal closes
    modalRef.hidden.subscribe(() => {
      this._updateUrlWithQueryParam('story', null);
    });
  }

  // public get selectedVariableGroup(){
  //     return this.host?.selectedVariableGroup
  // }
  toggleSubVariable(subVar: any, checked: boolean, variable) {
    //this.host?.selectedSubVariablesIds?.clear()
    if (checked && subVar) {
      this.selectedSubVariablesIds?.add(subVar.id);
      if (variable) {
        variable.selectedSubVarId = subVar.id;
      }
    } else {
      variable.selectedSubVarId = null;
      this.selectedSubVariablesIds?.delete(subVar.id);
    }

    variable.isOpen = false;
  }

  getSelectedSubTitles(variable: any): string[] {
    if (
      !variable?.bookingSubVariables?.length ||
      !this.selectedSubVariablesIds?.size
    ) {
      return [];
    }

    return variable.bookingSubVariables
      .filter((subVar: any) => this.selectedSubVariablesIds?.has(subVar?.id))
      .map((subVar: any) => subVar?.title)
      .filter(Boolean);
  }

  
  private getSubVar(subVarId){
    if(this.subVars.has(subVarId + "")){
      return this.subVars.get(subVarId + "")
    }
    for(const superGroup of this.variableSuperGroups)
    {
      for(const group of superGroup.bookingVariableGroups){
        for(const variable of group.bookingVariables){
          for(const subVar of variable.bookingSubVariables){
            if(subVar.id == subVarId){
              this.subVars.set(subVarId + '', subVar);
              return subVar
            }
          }
        }
      }
    }
    return null;
  }
  private getVariable(variableId){
    if(this.vars.has(variableId + "")){
      return this.vars.get(variableId + "")
    }
    for(const superGroup of this.variableSuperGroups)
    {
      for(const group of superGroup.bookingVariableGroups){
        for(const variable of group.bookingVariables){
            if(variable.id == variableId){
              this.vars.set(variableId + '', variable);
              return variable
            }
        }
      }
    }
    return null;

  }
  get selectedChoiceString() : string{
    let rv = []
    for(const v of [this.selectedVariableSuperGroup, this.selectedVariableGroup]){
       if(v){
        rv.push(v.title)
       }else{
        break
       }
    }
    for(const subVarId of this.selectedSubVariablesIds){
      const subVar = this.getSubVar(subVarId);
      if(subVar){
        const parentVariable = this.getVariable(subVar.bookingVariableId)
        if(parentVariable){
          rv.push(parentVariable.title);
          rv.push(subVar.title)
        }else{
          console.log('no var')
        }
      }else{
        console.log('no subvar')
      }

    }

    return rv.join('-')
    
  }
  get estimatorGroupSummaryTitle(): string {
    const defaultTitle = this.selectedVariableSuperGroup?.title ?? '';
    const variableGroup = this.selectedVariableGroup;

    if (!variableGroup?.bookingVariables?.length) {
      return defaultTitle;
    }

    const segments: string[] = [];
    const variableGroupTitle = variableGroup?.title ?? '';
    if (variableGroupTitle) {
      segments.push(variableGroupTitle);
    }

    // for (const variable of variableGroup.bookingVariables) {
    //     const selectedSubTitles = this.getSelectedSubTitles(variable);
    //     if (selectedSubTitles.length) {
    //         segments.push(`${selectedSubTitles.join(', ')}`);
    //     }
    // }

    const title = segments.length ? segments.join(' | ') : defaultTitle;
    return `${this.selectedVariableSuperGroup?.title} ${title}`;
  }

  getSubGroupEstimateValues(subGroup: any): number[] {
    if (!subGroup?.bookingVariables?.length) {
      return [];
    }

    const baseValue = Number(subGroup?.value ?? 0);
    const estimates = new Set<number>();

    for (const variable of subGroup.bookingVariables ?? []) {
      for (const subVar of variable?.bookingSubVariables ?? []) {
        const rawAmount = Number(subVar?.amount ?? 0);
        if (Number.isNaN(rawAmount)) {
          continue;
        }

        const computedDelta = subVar?.isPercent
          ? (rawAmount / 100) * baseValue
          : rawAmount;

        estimates.add(Number((baseValue + computedDelta).toFixed(2)));
      }
    }

    if (subGroup?.maxValue && Number(subGroup.maxValue) !== baseValue) {
      estimates.add(Number(subGroup.maxValue));
    }

    return Array.from(estimates).sort((a, b) => a - b);
  }

  onVariableHeaderClick(variable: any): void {
    if (!variable) {
      return;
    }

    if (variable.selectedSubVarId) {
      this.selectedSubVariablesIds?.delete(variable.selectedSubVarId);
      variable.selectedSubVarId = null;
      variable.isOpen = true;
      return;
    }

    variable.isOpen = !variable.isOpen;
  }
}
